export const getBaseUrl = () => {
	return process.env.API_URL;
}

